var map = {
	"./en.json": [
		174,
		174
	],
	"./ja.json": [
		980,
		980
	],
	"./ko.json": [
		423,
		423
	],
	"./zh.json": [
		527,
		527
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 96;
module.exports = webpackAsyncContext;